import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';

const stateOptions = [
    {value: '', label: 'All States'},
    {value: 'PENDING', label: 'Pending'},
    {value: 'EMITTED', label: 'Emitted'},
    {value: 'FAILED', label: 'Failed'},
    {value: 'RETRY', label: 'Retry'},
    {value: 'UNCERTAIN', label: 'Uncertain'},
];

const channelOptions = [
    {value: '', label: 'All Channels'},
    {value: 'STRIPE', label: 'Stripe'},
    {value: 'AWS_MARKETPLACE', label: 'AWS Marketplace'},
    {value: 'INTERNAL', label: 'Internal'},
];

export const FilterFormComponent = () => {
    return (
        <Stack gap='md' my='md'>
            <Field
                name='state'
                label='State'
                data={stateOptions}
                component={FormikSelect}
            />
            <Field
                name='channel'
                label='Channel'
                data={channelOptions}
                component={FormikSelect}
            />
            <Field
                name='customerId'
                label='Customer ID'
                component={FormikTextInput}
            />
            <Field
                name='dayStart'
                label='Day Start (ISO)'
                placeholder='2026-06-01T00:00:00.000Z'
                component={FormikTextInput}
            />
            <Field
                name='dayEnd'
                label='Day End (ISO)'
                placeholder='2026-06-02T00:00:00.000Z'
                component={FormikTextInput}
            />
        </Stack>
    );
};
